import RecordBase from './../tools/RecordBase';

class Precio extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'precios';
    this.title = 'Precio';
  }
}

export default Precio;
